import { List } from 'react-admin';

import { useTitle } from '@src/hooks/useTitle';
import {
  ApplyStatusStrip,
  FacetFilterSync,
  GuideAccordion,
  ResalePricingTabShell,
  RulesDatagrid,
  useRuleFilters,
} from '../shared';
import WithPricingGuard from './WithPricingGuard';
import ConditionDiscountsActions from './ConditionDiscountsActions';
import ConditionDiscountsDocumentation from './ConditionDiscountsDocumentation';

const PRICING_TYPE = 'condition' as const;

const ConditionDiscountsList = () => {
  const { title } = useTitle('Resale Pricing · Condition Discounts');
  const filters = useRuleFilters(PRICING_TYPE);

  return (
    <ResalePricingTabShell tab="conditionDiscounts">
      <WithPricingGuard>
        <List
          perPage={25}
          sort={{ field: 'position', order: 'ASC' }}
          title={title}
          filters={filters}
          actions={<ConditionDiscountsActions pricingType={PRICING_TYPE} />}
          exporter={false}
        >
          <FacetFilterSync />
          <ApplyStatusStrip pricingType={PRICING_TYPE} />
          <RulesDatagrid pricingType={PRICING_TYPE} />
        </List>
        <GuideAccordion title="How condition discounts work">
          <ConditionDiscountsDocumentation />
        </GuideAccordion>
      </WithPricingGuard>
    </ResalePricingTabShell>
  );
};

export default ConditionDiscountsList;
